var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"advertisement"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"advertisement__inner"},[_c('Clock',{staticClass:"advertisement__clock"})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }